/**
 * User faith (Existential — Faith workstream). Gates the Islamic spiritual layer
 * (The Criterion / Quran Mastery + prayer features). Only 'muslim' unlocks it
 * today; the rest are recorded and may unlock their own layers later. The 7
 * Existential Pillars stay worldview-neutral regardless.
 *
 * `null`/`'unspecified'` is treated as Muslim by `isIslamicFaith` so existing
 * users (no faith set) see NO change — the Islamic layer is opt-OUT.
 */
export type Faith =
  | 'muslim'
  | 'christian'
  | 'jewish'
  | 'hindu'
  | 'buddhist'
  | 'other'
  | 'secular'
  | 'unspecified';

export const FAITH_OPTIONS: { value: Faith; label: string }[] = [
  { value: 'muslim', label: 'Muslim' },
  { value: 'christian', label: 'Christian' },
  { value: 'jewish', label: 'Jewish' },
  { value: 'hindu', label: 'Hindu' },
  { value: 'buddhist', label: 'Buddhist' },
  { value: 'other', label: 'Other' },
  { value: 'secular', label: 'Secular / None' },
  { value: 'unspecified', label: 'Prefer not to say' },
];

export const FAITH_VALUES: Faith[] = FAITH_OPTIONS.map(o => o.value);

export const DEFAULT_FAITH: Faith = 'muslim';

/**
 * Whether the Islamic spiritual layer (The Criterion + prayer) is enabled. Only
 * 'muslim' (or null/unset — existing users default to Muslim) unlocks it; any
 * EXPLICIT non-Muslim choice (incl. 'unspecified' = "Prefer not to say") hides
 * it. The store defaults `faith` to 'muslim', so the null branch is a safety net.
 */
export function isIslamicFaith(faith: Faith | null | undefined): boolean {
  return faith == null || faith === 'muslim';
}
